import { createContext, useContext } from "react";

type HeaderContextType = {
  burger: boolean;
  setBurger: (value: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextType | null>(null)

export function useHeader() {
  // FIXME use jotai
  const ctx = useContext(HeaderContext)

  if (!ctx) {
    throw new Error("Header components must be used inside fucking Header")
  }

  return ctx
}
